window.addEventListener("resize", () => {
  checkHeroBannerText();
});

function checkHeroBannerText() {
  const headings = document.querySelectorAll(".banner__box .type--heading");
  if (headings && headings.length > 0) {
    headings.forEach((heading) => {
      if (heading.textContent.includes("Loving Place")) {
        if (window.innerWidth <= 1800) {
          heading.innerHTML = heading.textContent.replace(
            "Loving Place",
            "Loving<br>Place"
          );
        }
      } else if (heading.textContent.includes("LovingPlace" )) {
        if (window.innerWidth > 1800) {
          heading.innerHTML = heading.textContent.replace(
            "LovingPlace",
            "Loving Place"
          );
        }
      }
    });
  }
}

checkHeroBannerText();
